import { useQuery } from '@tanstack/react-query';
import type { ImpactCardsResponse } from '@seo/types';
import { apiGet } from '@/lib/api';

/**
 * `<ImpactCards>` data source.
 *
 * One card per logged action (brief exported, keyword tracked, audit completed,
 * ...) with any outcome checkpoints already attached at +7d / +28d. The API
 * returns this in one call so the impact strip can render 7d vs 28d columns
 * side-by-side without another round-trip.
 */
export function useImpactCards(projectId: string | undefined) {
  return useQuery({
    queryKey: ['impact-cards', projectId],
    enabled: !!projectId,
    queryFn: () =>
      apiGet<ImpactCardsResponse>(
        `/v1/projects/${encodeURIComponent(projectId!)}/impact-cards`,
      ),
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
}
